<template>
  <div>
    <div class="mb-24 flex justify-center md:hidden">
      <RevIllustration
        v-if="product.images?.[0]"
        :alt="product.images[0].description"
        class="mb-16"
        :height="224"
        :src="product.images[0].url"
        :width="224"
      />
    </div>

    <div class="relative">
      <div
        class="mood-main bg-surface-default-low border-static-default-hi rounded-sm relative border p-12 pt-24"
      >
        <div class="heading-3">
          {{ product.titles.default }}

          <div
            v-if="selectedColorCode"
            aria-hidden
            class="rounded-full ml-8 inline-block size-[12px]"
            data-test="selected-color-code"
            :style="{ background: selectedColorCode }"
          />
        </div>

        <ul v-if="options.length" class="mt-6 flex flex-wrap gap-8">
          <li v-for="option in options" :key="option.value">
            <RevTag
              :label="option.value"
              :variant="option.upgraded ? 'info' : 'secondary'"
              variation="outline"
            />
          </li>
        </ul>

        <div class="mt-12">
          <slot name="price" />
        </div>

        <slot name="addition" />
      </div>
    </div>

    <RevButton
      class="body-1-bold mb-8 mt-12"
      full-width="always"
      variant="primary"
      @click="$emit('add-to-cart')"
    >
      {{ addToCartLabel }}
    </RevButton>
  </div>
</template>

<script lang="ts" setup>
import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'
import { RevButton } from '@ds/components/Button'
import { RevIllustration } from '@ds/components/Illustration'
import { RevTag } from '@ds/components/Tag'

import type { RecapOption } from './utils/resolveRecapOptions'

withDefaults(
  defineProps<{
    product: GetProductResponse
    options: RecapOption[]
    selectedColorCode?: string
    addToCartLabel: string
  }>(),
  {
    selectedColorCode: undefined,
  },
)

defineEmits<{ 'add-to-cart': [] }>()
</script>
